<template>
  <ValidationProvider name="Ga Customer" slim vid="ga_customer_id" rules="required">
    <template #default="{ errors }">
      <BaseFormGroup>
        <BaseFormLabel for="ga_customer_id"> Customer </BaseFormLabel>
        <VSelect
          id="ga_customer_id"
          v-model="gaCustomerId"
          :options="gaCustomerOptions"
          label="name"
          :reduce="(gaCustomerOption) => gaCustomerOption.id"
          :disabled="disabled"
          class="vue-select custom-option"
          :filterable="false"
          @search="onSearch"
        >
          <template #option="{ id, name }">
            <div class="group px-4 py-2">
              <p class="text-sm font-medium text-gray-900 group-hover:text-white">
                {{ name }}
              </p>
              <span class="text-gray-400 group-hover:text-indigo-200 text-xs">{{ id }}</span>
            </div>
          </template>
          <template v-if="hasMore" #list-footer>
            <li class="flex space-x-2">
              <BaseButton
                primary
                outline
                small
                :disabled="!hasPrevPage"
                class="flex-1"
                @click="fetchPrevPage"
              >
                Prev
              </BaseButton>
              <BaseButton
                primary
                outline
                small
                :disabled="!hasNextPage"
                class="flex-1"
                @click="fetchNextPage"
              >
                Next
              </BaseButton>
            </li>
          </template>
        </VSelect>
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </BaseFormGroup>
    </template>
  </ValidationProvider>
</template>

<script>
import { googleAdsCustomersClient } from '@/api/clients';
import { debounce } from 'lodash-es';

export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    disabled: Boolean,
  },
  data() {
    return {
      gaCustomerOptions: [],
      meta: null,
      search: '',
      page: 1,
    };
  },
  computed: {
    gaCustomerId: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    hasMore() {
      return (this.meta?.total || 0) > (this.meta?.per_page || 0);
    },
    hasPrevPage() {
      return (this.meta?.current_page || 1) > 1;
    },
    hasNextPage() {
      return (this.meta?.last_page || 1) > (this.meta?.current_page || 1);
    },
  },
  created() {
    this.fetchGaCustomers();
  },
  methods: {
    onSearch(search, loading) {
      loading(true);
      this.searchOptions(loading, search, this);
    },
    searchOptions: debounce((loading, search, vm) => {
      // eslint-disable-next-line no-param-reassign
      vm.search = search;
      // eslint-disable-next-line no-param-reassign
      vm.page = 1;
      vm.fetchGaCustomers().finally(() => loading(false));
    }, 350),
    async fetchGaCustomers() {
      try {
        const response = await googleAdsCustomersClient.list({
          filter: {
            search: this.search,
          },
          page: this.page,
        });

        this.gaCustomerOptions = response.data;
        this.meta = response.meta;

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    fetchPrevPage() {
      if (!this.hasPrevPage) {
        return;
      }
      this.page = this.meta.current_page - 1;
      this.fetchOptions();
    },
    fetchNextPage() {
      if (!this.hasNextPage) {
        return;
      }
      this.page = this.meta.current_page + 1;
      this.fetchOptions();
    },
  },
};
</script>
